import * as React from 'react';
import Form from 'antd/lib/form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import withStyles from 'react-jss';
import { StylesProps, KeyLabel } from 'src/Library/Types';
import { searchCountry } from 'src/api/country';
import { useGenericState } from 'src/Library/UseGenericState';
import { useDebounce } from 'src/hooks/useDebounce';
import { renderSelectDropDown, renderInputField } from 'src/Library/Common';
import { Select } from 'src/Library/AntdLibComponents';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  rowDiv: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '14px',
    padding: 10,
    '& .ant-form-item': {
      margin: 0,
      padding: 0,
    },
    '& .ant-form-explain': {
      fontSize: tokens.fontSize.caption,
    },
  },
  title: {
    paddingTop: '5px',
    fontSize: `${tokens.fontSize.small}px`,
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
  },
  addCustom: {
    float: 'left',
    cursor: 'pointer',
    color: tokens.colors.primary,
    fontSize: `${tokens.fontSize.small}px`,
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  form;
}

interface StateProps {
  isSearchingCountry: boolean;
  searchTerm?: string;
  countryList: KeyLabel [];
}

const AddCustomCFSLocationModal = (props : IProps) => {
  const {
    form: { getFieldDecorator },
    classes,
    form,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    countryList: [],
    isSearchingCountry: false,
  });

  const {
    isSearchingCountry,
    searchTerm,
    countryList,
  } = state;

  const debouncedSearchCountry = useDebounce(searchTerm, 300);

  React.useEffect(() => {
    searchCountryList(debouncedSearchCountry);
  }, [debouncedSearchCountry]);

  const searchCountryList = async (queryString: string = '') => {
    setState({ isSearchingCountry: true });
    let countryList : KeyLabel [] = [];
    const response = await searchCountry({ queryString });
    if (response.isSuccess) {
      countryList = response.data.map(country => ({
        key: country.id,
        label: country.countryName,
      }))
    }
    setState({ countryList, isSearchingCountry: false });
  }

  const renderName = (): React.ReactElement => {
    return (
      <Row gutter={24} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Name*
        </Col>
        {renderInputField(form, 'name', 'Type Organisation Name', true)}
      </Row>
    );
  };

  const renderAddressLandmark = (): React.ReactElement => {
    return (
      <Row gutter={24} className={classes.rowDiv}>
        <Col span={4} className={classes.title}>
          Address Details*
        </Col>
        {renderInputField(form, 'address', 'Enter Address', true)}
        {renderInputField(form, 'landmark', 'Enter Landmark')}
      </Row>
    );
  };

  const renderCityState = (): React.ReactElement => {
    return (
      <Row gutter={24} className={classes.rowDiv}>
        <Col span={4} className={classes.title}></Col>
        {renderInputField(form, 'pincode', 'PIN Code', false, 4)}
        {renderInputField(form, 'city', 'City', false, 6, 0)}
        {renderInputField(form, 'state', 'State', false, 6)}
        <Col span={4} style={{ paddingLeft: 0 }}>
          <Form.Item>
            {getFieldDecorator('countryId',
            {
              rules: [{ required: true, message: 'Required' }],
            })(
              <Select
                getPopupContainer={(trigger: any) => trigger.parentNode}
                showSearch
                placeholder="Country"
                onSearch={val => setState({ searchTerm: val })}
                onFocus={() => setState({ searchTerm: '' })}
                allowClear
                filterOption={(input, option) => true}
                dropdownMatchSelectWidth={false}
                dropdownRender={menu => renderSelectDropDown(menu, isSearchingCountry)}>
                {countryList?.map(item => (
                  <Select.Option key={item.key}>{item.label}</Select.Option>
                ))}
              </Select>)}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  return (
    <Form style={{height: '350px'}}>
      {renderName()}
      {renderAddressLandmark()}
      {renderCityState()}
    </Form>
  );
};

export default withStyles(styles)(React.memo(AddCustomCFSLocationModal));
